export default __webpack_public_path__ + "src/assets/edit.d76be6682b034b3826f4fe4f5d4109a7.svg";